import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@components/atoms/Card';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { formatPrice } from '@utils/format';
import { useThemes } from '@hooks/useThemes';
import styles from './ConfirmServiceCard.module.css';

interface ConfirmServiceCardProps {
    name: string;
    quantity: number;
    price?: number;
    duration?: number;
}

export const ConfirmServiceCard: FC<ConfirmServiceCardProps> = ({ name, quantity, price, duration }) => {
    const { useGrayscaleTheme } = useThemes();
    const { t } = useTranslation();

    const translations = {
        durationLabel: t('confirm-service-card-component.duration.label'),
        minutesLabel: t('confirm-service-card-component.minutes-label', { count: duration }),
        quantityLabel: t('confirm-service-card-component.quantity.label'),
    };

    return (
        <Card classes={`${useGrayscaleTheme ? styles['theme-grayscale'] : ''} p-4`}>
            <div className="d-grid pt-2 pt-md-0">
                <Card.Title
                    typography={{
                        classes: 'text-truncate mb-2',
                        fontSize: '14',
                        color: 'dark',
                        fontWeight: '900',
                        breakpointsStyles: { md: { fontSize: '16' } },
                        children: name,
                    }}
                />
                {price !== undefined && (
                    <Typography
                        classes={`${styles.price} mb-0`}
                        fontSize="20"
                        fontWeight="800"
                        breakpointsStyles={{ md: { fontSize: '24' } }}>
                        {formatPrice(price)}
                    </Typography>
                )}

                {duration ? (
                    <Typography classes="mb-0 mb-md-1" fontSize="14">
                        <>
                            {`${translations.durationLabel} `}
                            <Typography tagVariant={TypographyTagVariants.span} fontWeight="900">
                                {`${translations.minutesLabel}`}
                            </Typography>
                        </>
                    </Typography>
                ) : (
                    <></>
                )}

                <Typography classes="mb-0" fontSize="14" color="muted">
                    {`${translations.quantityLabel} ${quantity}`}
                </Typography>
            </div>
        </Card>
    );
};
